import { cn } from "@/lib/utils";

type Tone = "primary" | "strong" | "neutral" | "violet";

const toneClass: Record<Tone, string> = {
  primary: "bg-brand-tint text-brand",
  strong: "bg-brand text-white",
  neutral: "bg-[rgba(112,115,124,0.1)] text-label-alt",
  violet: "bg-[rgba(124,77,255,0.1)] text-[#6d3fe0]",
};

/** Wanted DS ContentBadge 대응 — 작은 필 라벨. */
export function ContentBadge({
  children,
  tone = "neutral",
  className,
}: {
  children: React.ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-[12px] font-semibold leading-none",
        toneClass[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
